import React, { Component } from "react";
import PropTypes from "prop-types";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import TableHead from "@material-ui/core/TableHead";

// styles
import styles from "./styles";

class RendTableHead extends Component {
  static propTypes = {
    classes: PropTypes.object,
    children: PropTypes.any,
  };

  render() {
    const { children } = this.props;

    return <TableHead>{children}</TableHead>;
  }
}

export default withStyles(styles)(RendTableHead);
